import {BaseUser, UserType} from '@legit.health/ui';
import Patient from '@/patient/interfaces/Patient';

export default function isPatient(user: BaseUser): user is Patient {
  return (user as Patient).type === UserType.Patient;
}
